import { useAuthStore } from "../stores/authStore";

export const usePermissions = () => {
  const { user } = useAuthStore();

  const roleName = user?.role_name?.toLowerCase();

  // Admin or Superadmin can edit/delete/create
  const canEdit = roleName === "admin" || roleName === "superadmin";
  const canCreate = roleName === "admin" || roleName === "superadmin";
  const canDelete = roleName === "admin" || roleName === "superadmin";

  // Specific check for superadmin if needed
  const isSuperAdmin = roleName === "superadmin";

  return {
    canEdit,
    canCreate,
    canDelete,
    isSuperAdmin,
    role: roleName,
  };
};
